import React from 'react'

import './styles.scss'
import { lang } from 'utils/helpers'
import { getNotificationIcon, getClassNames } from './utils'

/**
 * ToastNotificationStatus
 * @param {object} props
 * @param {"ok"|"error"} props.type
 * @param {string} props.text
 * @param {boolean} [props.disableInternationalization]
 * @param {string} [props.className]
 */
const ToastNotificationStatus = (props) => {
  const { type, text, disableInternationalization = false, className } = props

  const textValue = disableInternationalization ? text : lang(text)
  const iconValue = getNotificationIcon(type)
  const classValue = getClassNames({ statusType: type, customClass: className })

  return (
    <div className={`toast-notification-status${classValue}`}>
      <figure className='toast-notification-status__icon'>
        {
          iconValue
            ? <img src={iconValue.url} alt={iconValue.description} />
            : null
        }
      </figure>
      <p className='toast-notification-status__text'>{textValue}</p>
    </div>
  )
}

export default ToastNotificationStatus
